import { toURLSearchParams } from '@wix/metro-runtime';
import { serializer } from '@wix/metro-runtime/ambassador';
import { resolveUrl } from '@wix/metro-runtime';
var _bulkDeleteFormSpamSubmissionReportByFilterRequest = {};
var _bulkDeleteFormSpamSubmissionReportByFilterResponse = {};
var _bulkDeleteFormSpamSubmissionReportRequest = {};
var _bulkDeleteFormSpamSubmissionReportResponse = {};
var _bulkReportNotSpamSubmissionRequest = {};
var _bulkReportNotSpamSubmissionResponse = {};
var _bulkReportSpamSubmissionRequest = {};
var _bulkReportSpamSubmissionResponse = {
    results: '_bulkReportSpamSubmissionResult',
};
var _bulkReportSpamSubmissionResult = { item: '_formSpamSubmissionReport' };
var _checkForSpamRequest = { submission: '_formSubmission' };
var _checkForSpamResponse = {};
var _countFormSpamSubmissionReportsRequest = {};
var _countFormSpamSubmissionReportsResponse = {};
var _createFormSpamSubmissionReportRequest = {
    formSpamSubmissionReport: '_formSpamSubmissionReport',
};
var _createFormSpamSubmissionReportResponse = {
    formSpamSubmissionReport: '_formSpamSubmissionReport',
};
var _deleteFormSpamSubmissionReportRequest = {};
var _deleteFormSpamSubmissionReportResponse = {};
var _formSpamSubmissionReport = {
    createdDate: 'google.protobuf.Timestamp',
    reportedDate: 'google.protobuf.Timestamp',
    updatedDate: 'google.protobuf.Timestamp',
};
var _formSubmission = {
    createdDate: 'google.protobuf.Timestamp',
    updatedDate: 'google.protobuf.Timestamp',
};
var _getFormSpamSubmissionReportRequest = {};
var _getFormSpamSubmissionReportResponse = {
    formSpamSubmissionReport: '_formSpamSubmissionReport',
};
var _queryFormSpamSubmissionReportsByNamespaceRequest = {};
var _queryFormSpamSubmissionReportsByNamespaceResponse = {
    formSpamSubmissionReports: '_formSpamSubmissionReport',
};
var _reportNotSpamSubmissionRequest = {};
var _reportNotSpamSubmissionResponse = { submission: '_formSubmission' };
var _reportSpamSubmissionRequest = {};
var _reportSpamSubmissionResponse = {
    formSpamSubmissionReport: '_formSpamSubmissionReport',
};
function resolveWixFormsV4FormSpamSubmissionReportServiceUrl(opts) {
    var domainToMappings = {
        '*.dev.wix-code.com': [
            {
                srcPath: '/_api/form-spam-submission-report-service',
                destPath: '',
            },
        ],
        _: [
            {
                srcPath: '/_api/form-spam-submission-report-service',
                destPath: '',
            },
        ],
        'apps._base_domain_': [
            {
                srcPath: '/_api/form-spam-submission-report-service',
                destPath: '',
            },
        ],
        'editor._base_domain_': [
            {
                srcPath: '/_api/form-spam-submission-report-service',
                destPath: '',
            },
        ],
        'blocks._base_domain_': [
            {
                srcPath: '/_api/form-spam-submission-report-service',
                destPath: '',
            },
        ],
        'create.editorx': [
            {
                srcPath: '/_api/form-spam-submission-report-service',
                destPath: '',
            },
        ],
        'editor.wixapps.net': [
            {
                srcPath: '/_api/form-spam-submission-report-service',
                destPath: '',
            },
        ],
        'manage._base_domain_': [
            {
                srcPath: '/_api/form-spam-submission-report-service',
                destPath: '',
            },
            {
                srcPath: '/form-spam-submission-report-service',
                destPath: '',
            },
        ],
        'www._base_domain_': [
            {
                srcPath: '/_api/form-spam-submission-report-service',
                destPath: '',
            },
        ],
        'www.wixapis.com': [
            {
                srcPath: '/form-spam-submission-report-service',
                destPath: '',
            },
        ],
    };
    return resolveUrl(Object.assign(opts, { domainToMappings: domainToMappings }));
}
/** Checks if submission is a spam. */
export function checkForSpam(payload) {
    var _a = serializer(_checkForSpamRequest, { _formSubmission: _formSubmission }), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_checkForSpamResponse, {}).fromJSON;
    function __checkForSpam(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.forms.v4.form_spam_submission_report',
            method: 'POST',
            methodFqn: 'wix.forms.v4.FormSpamSubmissionReportService.CheckForSpam',
            url: resolveWixFormsV4FormSpamSubmissionReportServiceUrl({
                protoPath: '/v4/form-spam-submission-reports/check-for-spam',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __checkForSpam.fromReq = fromReq;
    __checkForSpam.__isAmbassador = true;
    return __checkForSpam;
}
/**
 * Creates a new spam submission.
 * To upload submission media, use the FormSubmissionService.getMediaUploadUrl endpoint.
 */
export function createFormSpamSubmissionReport(payload) {
    var _a = serializer(_createFormSpamSubmissionReportRequest, { _formSpamSubmissionReport: _formSpamSubmissionReport }), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_createFormSpamSubmissionReportResponse, { _formSpamSubmissionReport: _formSpamSubmissionReport }).fromJSON;
    function __createFormSpamSubmissionReport(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.forms.v4.form_spam_submission_report',
            method: 'POST',
            methodFqn: 'wix.forms.v4.FormSpamSubmissionReportService.CreateFormSpamSubmissionReport',
            url: resolveWixFormsV4FormSpamSubmissionReportServiceUrl({
                protoPath: '/v4/form-spam-submission-reports',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __createFormSpamSubmissionReport.fromReq = fromReq;
    __createFormSpamSubmissionReport.__isAmbassador = true;
    return __createFormSpamSubmissionReport;
}
/** Get a spam submission by id. */
export function getFormSpamSubmissionReport(payload) {
    var _a = serializer(_getFormSpamSubmissionReportRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_getFormSpamSubmissionReportResponse, { _formSpamSubmissionReport: _formSpamSubmissionReport }).fromJSON;
    function __getFormSpamSubmissionReport(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.forms.v4.form_spam_submission_report',
            method: 'GET',
            methodFqn: 'wix.forms.v4.FormSpamSubmissionReportService.GetFormSpamSubmissionReport',
            url: resolveWixFormsV4FormSpamSubmissionReportServiceUrl({
                protoPath: '/v4/form-spam-submission-reports/{formSpamSubmissionReportId}',
                data: serializedData,
                host: host,
            }),
            params: toURLSearchParams(serializedData),
            transformResponse: fromRes,
        };
        return metadata;
    }
    __getFormSpamSubmissionReport.fromReq = fromReq;
    __getFormSpamSubmissionReport.__isAmbassador = true;
    return __getFormSpamSubmissionReport;
}
/** Delete a spam submission report. */
export function deleteFormSpamSubmissionReport(payload) {
    var _a = serializer(_deleteFormSpamSubmissionReportRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_deleteFormSpamSubmissionReportResponse, {}).fromJSON;
    function __deleteFormSpamSubmissionReport(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.forms.v4.form_spam_submission_report',
            method: 'DELETE',
            methodFqn: 'wix.forms.v4.FormSpamSubmissionReportService.DeleteFormSpamSubmissionReport',
            url: resolveWixFormsV4FormSpamSubmissionReportServiceUrl({
                protoPath: '/v4/form-spam-submission-reports/{formSpamSubmissionReportId}',
                data: serializedData,
                host: host,
            }),
            params: toURLSearchParams(serializedData),
            transformResponse: fromRes,
        };
        return metadata;
    }
    __deleteFormSpamSubmissionReport.fromReq = fromReq;
    __deleteFormSpamSubmissionReport.__isAmbassador = true;
    return __deleteFormSpamSubmissionReport;
}
/** Deletes report by IDS or all for specific form. */
export function bulkDeleteFormSpamSubmissionReport(payload) {
    var _a = serializer(_bulkDeleteFormSpamSubmissionReportRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_bulkDeleteFormSpamSubmissionReportResponse, {}).fromJSON;
    function __bulkDeleteFormSpamSubmissionReport(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.forms.v4.form_spam_submission_report',
            method: 'POST',
            methodFqn: 'wix.forms.v4.FormSpamSubmissionReportService.BulkDeleteFormSpamSubmissionReport',
            url: resolveWixFormsV4FormSpamSubmissionReportServiceUrl({
                protoPath: '/v4/bulk/form-spam-submission-reports/delete',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __bulkDeleteFormSpamSubmissionReport.fromReq = fromReq;
    __bulkDeleteFormSpamSubmissionReport.__isAmbassador = true;
    return __bulkDeleteFormSpamSubmissionReport;
}
/** Deletes reports by filter for specific form. */
export function bulkDeleteFormSpamSubmissionReportByFilter(payload) {
    var _a = serializer(_bulkDeleteFormSpamSubmissionReportByFilterRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_bulkDeleteFormSpamSubmissionReportByFilterResponse, {}).fromJSON;
    function __bulkDeleteFormSpamSubmissionReportByFilter(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.forms.v4.form_spam_submission_report',
            method: 'POST',
            methodFqn: 'wix.forms.v4.FormSpamSubmissionReportService.BulkDeleteFormSpamSubmissionReportByFilter',
            url: resolveWixFormsV4FormSpamSubmissionReportServiceUrl({
                protoPath: '/v4/bulk/form-spam-submission-reports/delete-by-filter',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __bulkDeleteFormSpamSubmissionReportByFilter.fromReq = fromReq;
    __bulkDeleteFormSpamSubmissionReportByFilter.__isAmbassador = true;
    return __bulkDeleteFormSpamSubmissionReportByFilter;
}
/**
 * Report a spam submission as not spam. The submission is created, and the spam report is deleted.
 * Submission automations are triggered the same way as in standard submission creation flow.
 */
export function reportNotSpamSubmission(payload) {
    var _a = serializer(_reportNotSpamSubmissionRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_reportNotSpamSubmissionResponse, {
        _formSubmission: _formSubmission,
    }).fromJSON;
    function __reportNotSpamSubmission(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.forms.v4.form_spam_submission_report',
            method: 'POST',
            methodFqn: 'wix.forms.v4.FormSpamSubmissionReportService.ReportNotSpamSubmission',
            url: resolveWixFormsV4FormSpamSubmissionReportServiceUrl({
                protoPath: '/v4/form-spam-submission-reports/{formSpamSubmissionReportId}/report-not-spam-submission',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __reportNotSpamSubmission.fromReq = fromReq;
    __reportNotSpamSubmission.__isAmbassador = true;
    return __reportNotSpamSubmission;
}
/**
 * Report a spam submissions as not spam. The submissions is created, and the spam reports is deleted.
 * Submissions automations are triggered the same way as in standard submission creation flow.
 */
export function bulkReportNotSpamSubmission(payload) {
    var _a = serializer(_bulkReportNotSpamSubmissionRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_bulkReportNotSpamSubmissionResponse, {}).fromJSON;
    function __bulkReportNotSpamSubmission(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.forms.v4.form_spam_submission_report',
            method: 'POST',
            methodFqn: 'wix.forms.v4.FormSpamSubmissionReportService.BulkReportNotSpamSubmission',
            url: resolveWixFormsV4FormSpamSubmissionReportServiceUrl({
                protoPath: '/v4/bulk/form-spam-submission-reports/report-not-spam-submission',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __bulkReportNotSpamSubmission.fromReq = fromReq;
    __bulkReportNotSpamSubmission.__isAmbassador = true;
    return __bulkReportNotSpamSubmission;
}
/** Report a submission as spam. The spam submission report is created, and the submission is deleted. */
export function reportSpamSubmission(payload) {
    var _a = serializer(_reportSpamSubmissionRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_reportSpamSubmissionResponse, {
        _formSpamSubmissionReport: _formSpamSubmissionReport,
    }).fromJSON;
    function __reportSpamSubmission(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.forms.v4.form_spam_submission_report',
            method: 'POST',
            methodFqn: 'wix.forms.v4.FormSpamSubmissionReportService.ReportSpamSubmission',
            url: resolveWixFormsV4FormSpamSubmissionReportServiceUrl({
                protoPath: '/v4/submissions/{submissionId}/report-spam-submission',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __reportSpamSubmission.fromReq = fromReq;
    __reportSpamSubmission.__isAmbassador = true;
    return __reportSpamSubmission;
}
/** Report multiple submissions as spam. The spam submission reports is created, and the submissions is deleted. */
export function bulkReportSpamSubmission(payload) {
    var _a = serializer(_bulkReportSpamSubmissionRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_bulkReportSpamSubmissionResponse, {
        _bulkReportSpamSubmissionResult: _bulkReportSpamSubmissionResult,
        _formSpamSubmissionReport: _formSpamSubmissionReport,
    }).fromJSON;
    function __bulkReportSpamSubmission(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.forms.v4.form_spam_submission_report',
            method: 'POST',
            methodFqn: 'wix.forms.v4.FormSpamSubmissionReportService.BulkReportSpamSubmission',
            url: resolveWixFormsV4FormSpamSubmissionReportServiceUrl({
                protoPath: '/v4/bulk/submissions/report-spam-submission',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __bulkReportSpamSubmission.fromReq = fromReq;
    __bulkReportSpamSubmission.__isAmbassador = true;
    return __bulkReportSpamSubmission;
}
/** Query form spam submission reports using [WQL - Wix Query Language](https://dev.wix.com/api/rest/getting-started/api-query-language). */
export function queryFormSpamSubmissionReportsByNamespace(payload) {
    var _a = serializer(_queryFormSpamSubmissionReportsByNamespaceRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_queryFormSpamSubmissionReportsByNamespaceResponse, { _formSpamSubmissionReport: _formSpamSubmissionReport }).fromJSON;
    function __queryFormSpamSubmissionReportsByNamespace(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.forms.v4.form_spam_submission_report',
            method: 'POST',
            methodFqn: 'wix.forms.v4.FormSpamSubmissionReportService.QueryFormSpamSubmissionReportsByNamespace',
            url: resolveWixFormsV4FormSpamSubmissionReportServiceUrl({
                protoPath: '/v4/form-spam-submission-reports/namespace/query',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __queryFormSpamSubmissionReportsByNamespace.fromReq = fromReq;
    __queryFormSpamSubmissionReportsByNamespace.__isAmbassador = true;
    return __queryFormSpamSubmissionReportsByNamespace;
}
/** Counts the number of spam submission reports belonging to the specified forms. */
export function countFormSpamSubmissionReports(payload) {
    var _a = serializer(_countFormSpamSubmissionReportsRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_countFormSpamSubmissionReportsResponse, {}).fromJSON;
    function __countFormSpamSubmissionReports(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.forms.v4.form_spam_submission_report',
            method: 'POST',
            methodFqn: 'wix.forms.v4.FormSpamSubmissionReportService.CountFormSpamSubmissionReports',
            url: resolveWixFormsV4FormSpamSubmissionReportServiceUrl({
                protoPath: '/v4/form-spam-submission-reports/count',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __countFormSpamSubmissionReports.fromReq = fromReq;
    __countFormSpamSubmissionReports.__isAmbassador = true;
    return __countFormSpamSubmissionReports;
}
//# sourceMappingURL=http.impl.js.map